import type { CategoryBreakdown } from '@apply/lending-limits';
import { SBARows } from '../components/lendingLimitAccordionPanel/components/common/constants/tables/rows/SBARows';
import { ISBATableRow } from '../components/lendingLimitAccordionPanel/components/common/constants/tables/interfaces/ISBATableRow';
import { detailRow, fromBucket } from './shared';

/**
 * SBA grid rows — line-of-credit exposure only, so a single row and no total.
 *
 * The BE collapses each line of credit (master note plus its sub-notes) to one loan
 * before it gets here, so the count is a count of facilities, not of draws.
 */
export function toSBARows(breakdown: CategoryBreakdown): ISBATableRow[] {
    return [
        {
            summaryItemType: SBARows.LineOfCredit,
            ...detailRow(fromBucket(breakdown.buckets.lineOfCredit)),
        },
    ];
}
